export enum IndicadoresDashboardRouter {
  Index = "dashboard_index"
}
